module.exports = __webpack_public_path__ + "img/banner2.7f9895e8.png";